import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { HOTSPOT_SCALE } from '../../../utils';
import Plane from '../Plane/Plane';
const SelectedEntityPositionHotspot = ({ onPointerMove, onPointerUp }) => {
    const is3dMode = useSelector((state) => state.userReducer.is3dMode);
    const isScreenRelativeMode = useSelector((state) => state.userReducer.isScreenRelativeMode);
    return !is3dMode || isScreenRelativeMode ? (_jsx(Plane, { visible: false, color: [255, 0, 0, 0.2], enabled: true, rotation: [0, 0, 0], position: [0, 0, 0], scale: HOTSPOT_SCALE, pointerMoveHandler: onPointerMove, pointerUpHandler: onPointerUp })) : null;
};
export default SelectedEntityPositionHotspot;
